<div class="main-container" ymResize [breakpoint]="breakpoints.MD"
    (isInsideBreakpoint)="updatedInsideBreakpoint($event)">
    <ng-container *ngIf="component === skeletonComponentEnums.DEFAULT">
        <ng-container *ngFor="let item of mdArray">
            <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-p-5">
                <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                <ym-skeleton-paragraph class="ym-max-w-80"></ym-skeleton-paragraph>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.CONTACT_LIST">
        <div>
            <div class="ym-display-flex ym-gap-3 ym-px-5 ym-pt-3 ym-pb-5 ym-w-full ym-max-w-62">
                <ng-container *ngFor="let item of mdArray">
                    <ym-skeleton-button class="ym-w-full"></ym-skeleton-button>
                </ng-container>
            </div>
        </div>
        <ng-container *ngFor="let item of lgArray">
            <div class="ym-display-flex ym-gap-3 ym-px-5 ym-py-3">
                <ym-skeleton-avatar [size]="avatarSizes.LG"></ym-skeleton-avatar>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                    <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.SEARCH">
        <ng-container *ngFor="let item of lgArray">
            <div class="ym-display-flex ym-gap-3 ym-px-5 ym-py-3">
                <ym-skeleton-avatar [size]="avatarSizes.LG"></ym-skeleton-avatar>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                    <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.AUTOMATION_LIST">
        <div>
            <div class="ym-display-flex ym-gap-3 ym-p-5 ym-pt-3 ym-pb-5 ym-w-full ym-max-w-62">
                <ng-container *ngFor="let item of smArray">
                    <ym-skeleton-button class="ym-w-full"></ym-skeleton-button>
                </ng-container>
            </div>
        </div>
        <ng-container *ngFor="let item of lgArray">
            <div class="ym-display-flex ym-gap-3 ym-px-5 ym-py-3">
                <ym-skeleton-avatar [size]="avatarSizes.LG" [isCircle]="false"></ym-skeleton-avatar>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                    <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.WORKFLOW">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-gap-7 ym-mb-5 ym-flex-direction-column">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-5 ym-w-full ym-mb-5">
                    <ym-skeleton-heading class="ym-max-w-34 ym-w-full"></ym-skeleton-heading>
                    <ym-skeleton-heading class="ym-max-w-48 ym-w-full" [heading]="1"></ym-skeleton-heading>
                </div>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-5 ym-w-full">
                    <ym-skeleton-heading class="ym-max-w-34 ym-w-full"></ym-skeleton-heading>
                    <ng-container *ngFor="let item of mdArray">
                        <ym-skeleton-heading class="ym-max-w-48 ym-w-full" [heading]="1"></ym-skeleton-heading>
                    </ng-container>
                </div>
            </div>

        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.CONTACT">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-gap-3 ym-mb-5 ym-flex-direction-column ym-align-items-center">
                <ym-skeleton-avatar [size]="avatarSizes.XL"></ym-skeleton-avatar>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-align-items-center">
                    <ym-skeleton-heading class="ym-max-w-48 ym-w-full"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26 ym-w-full"></ym-skeleton-text>
                </div>
                <div class="ym-display-flex ym-gap-3 ym-p-5 ym-w-full ym-max-w-62">
                    <ng-container *ngFor="let item of mdArray">
                        <ym-skeleton-button class="ym-w-full"></ym-skeleton-button>
                    </ng-container>
                </div>
            </div>
            <ng-container *ngFor="let item of lgArray">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-py-5">
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    <ym-skeleton-heading [heading]="2"></ym-skeleton-heading>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.FIELDS">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-mb-5">
                <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                <ym-skeleton-paragraph class="ym-max-w-80"></ym-skeleton-paragraph>
            </div>
            <ng-container *ngFor="let item of lgArray">
                <div class="ym-display-flex ym-gap-3 ym-py-5">
                    <ym-skeleton-icon></ym-skeleton-icon>
                    <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                        <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                        <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.USERS">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-mb-5">
                <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                <ym-skeleton-paragraph class="ym-max-w-80"></ym-skeleton-paragraph>
            </div>
            <ng-container *ngFor="let item of lgArray">
                <div class="ym-display-flex ym-gap-3 ym-py-5">
                    <ym-skeleton-avatar [size]="avatarSizes.LG"></ym-skeleton-avatar>
                    <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                        <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                        <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    </div>
                </div>
            </ng-container>
        </div>

    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.DETAILS">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-mb-5">
                <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                <ym-skeleton-paragraph class="ym-max-w-80"></ym-skeleton-paragraph>
            </div>
            <ng-container *ngFor="let item of lgArray">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-py-5">
                    <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.ORGANISATION_LIST">
        <div>
            <ng-container *ngFor="let item of smArray">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-py-5">
                    <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                    <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.HOME">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-gap-3 ym-mb-5 ym-flex-direction-column ym-align-items-center">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full ym-align-items-center">
                    <ym-skeleton-text class="ym-max-w-26 ym-w-full"></ym-skeleton-text>
                    <ym-skeleton-heading class="ym-max-w-48 ym-w-full"></ym-skeleton-heading>
                </div>
                <div class="ym-display-flex ym-gap-3 ym-mt-5 ym-w-full ym-max-w-62">
                    <ym-skeleton-ui class="ym-w-full"></ym-skeleton-ui>
                    <ym-skeleton-ui class="ym-w-full"></ym-skeleton-ui>
                </div>
                <div class="ym-display-flex ym-gap-3 ym-w-full ym-max-w-62">
                    <ym-skeleton-ui class="ym-w-full"></ym-skeleton-ui>
                    <ym-skeleton-ui class="ym-w-full"></ym-skeleton-ui>
                </div>
            </div>
            <ym-skeleton-heading [heading]="1"
                class="ym-max-w-15 ym-display-block ym-mt-8 ym-mb-3"></ym-skeleton-heading>
            <ng-container *ngFor="let item of mdArray">
                <div class="ym-display-flex ym-gap-3 ym-py-3">
                    <ym-skeleton-avatar></ym-skeleton-avatar>
                    <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                        <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                        <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    </div>
                </div>
            </ng-container>
            <ym-skeleton-heading [heading]="1"
                class="ym-max-w-15 ym-display-block ym-mt-8 ym-mb-3"></ym-skeleton-heading>
            <ng-container *ngFor="let item of mdArray">
                <div class="ym-display-flex ym-gap-3 ym-py-3">
                    <ym-skeleton-avatar [size]="avatarSizes.LG"></ym-skeleton-avatar>
                    <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                        <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                        <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.HOME_SECTION">
        <div class="ym-p-5">
            <ng-container *ngFor="let item of mdArray">
                <div class="ym-display-flex ym-gap-3 ym-py-3">
                    <ym-skeleton-avatar></ym-skeleton-avatar>
                    <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                        <ym-skeleton-heading class="ym-max-w-48"></ym-skeleton-heading>
                        <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="component === skeletonComponentEnums.INVITE_SETUP">
        <div class="ym-p-5">
            <div class="ym-display-flex ym-gap-3 ym-py-5 ym-mb-3">
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                    <ym-skeleton-text class="ym-max-w-15"></ym-skeleton-text>
                    <ym-skeleton-heading></ym-skeleton-heading>
                </div>
                <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                    <ym-skeleton-text class="ym-max-w-15"></ym-skeleton-text>
                    <ym-skeleton-heading></ym-skeleton-heading>
                </div>
            </div>
            <div class="ym-display-flex ym-flex-direction-column ym-gap-3 ym-w-full">
                <ym-skeleton-text class="ym-max-w-26"></ym-skeleton-text>
                <ym-skeleton-heading></ym-skeleton-heading>
            </div>
            <div class="ym-mt-8 ym-display-flex ym-justify-content-center">
                <ym-skeleton-button class="ym-w-full"></ym-skeleton-button>
            </div>
        </div>

    </ng-container>
</div>